import { InteractionType } from "@datamole/wds-azure-auth";

/**
 * Set preferred interaction type for token acquisition
 * Choose Redirect or Popup
 */
export const AZURE_AD_INTERACTION_TYPE = InteractionType.Redirect;
